import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-0" }

import { watch, reactive, computed } from "vue";
import { useI18n } from "vue-i18n";

type ViewModel = {
  newCatalogName: string | null;
  errorMsg: string | null;
};

const maxStringLength = 256;


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogNamingExternal',
  emits: ["change"],
  setup(__props, { emit }) {

const { t } = useI18n();



//#region ViewModel
const vm = reactive<ViewModel>({
  newCatalogName: "",
  errorMsg: ""
});

const catalogValidation = computed(() => {
  const name = vm.newCatalogName?.trim() || "";

  let errorMsg = "";
  let isValid = true;

  if (name.length <= 0) {
    isValid = false;
    errorMsg = t("ErrorMessage.Mandatory");
  } else if (name.length > maxStringLength) {
    isValid = false;
    errorMsg = t("ErrorMessage.Max256");
  }

  return {
    isValid,
    errorMsg
  };
});

const onInput = () => {
  if (vm.newCatalogName !== null) {
    emit("change", {
      name: vm.newCatalogName,
      isValid: catalogValidation.value.isValid
    });
  }
};

watch(
  () => vm.newCatalogName,
  () => {
    onInput();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_tooltip = _resolveComponent("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, _toDisplayString(_unref(t)("GenerateCatalogFromTextFile.CatalogNaming.Part1")), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_b_input, {
        id: "catalog-naming-name",
        modelValue: vm.newCatalogName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.newCatalogName) = $event)),
        class: _normalizeClass({ 'border-danger': !catalogValidation.value.isValid }),
        onInput: onInput
      }, null, 8, ["modelValue", "class"]),
      (!catalogValidation.value.isValid)
        ? (_openBlock(), _createBlock(_component_b_tooltip, {
            key: 0,
            target: "catalog-naming-name",
            triggers: ['hover'],
            noninteractive: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(catalogValidation.value.errorMsg), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)("GenerateCatalogFromTextFile.CatalogNaming.Continue", {
          BackButton: _unref(t)("Back"),
          ContinueButton: _unref(t)("Continue")
        })), 1)
  ]))
}
}

})